$('#FetchVal').click(function(){
  var search = $('#Search_Number').val();
  if(search!=''){
    $('.gia-result-loader').show();
    $(this).attr('disabled','disabled');
    get_data(search,'all_data');
  }else{
    $('.gia-result-loader').hide();
    $(this).removeAttr('disabled');
  }
  $('#hidden-gia-val').val(search);
  $('.gia-form-success-message').hide();
});


function get_data(search,append_div){
  $('#'+append_div).hide();
  
  $.get("https://www.stonealgo.com/diamond-details/gia-number-"+search, function( data ) {
//   var url = 'https://apps.dotmagicinfotech.com/ryderstory/getdata.php';
  $('.gia-result-loader').show();
  $('#FetchVal').attr('disabled','disabled');
//   $.ajax({
//     url:url,
//     type:"POST",
//     async:false,
//     data:{diamond_id:search},
//     success:function(data){
      $('.gia-result-loader').hide();
      
//       var data = JSON.parse(data);
      if(data!=''){
      $('#'+append_div).html(data);
      $('#'+append_div).filter('script[src]').each(function (i, e) {
        var script = document.createElement('script');
        script.src = (e.nodeName == "LINK") ? $(this).attr('href') : $(this).attr('src');
        script.type = 'text/javascript';
        document.getElementsByTagName('head')[0].appendChild(script);
        $(this).remove();
      });

      var getcss = new Array();
      $('#'+append_div).filter('link[rel="stylesheet"]').each(function (i, e) {
        var css = document.createElement("link");
        css.type = "text/css";
        css.rel = "stylesheet";
        css.href = (e.nodeName == "LINK") ? $(this).attr('href') : $(this).attr('src');
        document.getElementsByTagName('head')[0].append(css);

      });

      $('#sa-thumb_1').parents('.hidden').remove();
      $('#sa-secondary_search_similar').parents('.py-2').find('.mt-5 .tracking-wider').parent().remove();
      $('#sa-secondary_search_similar').parents('.block').remove();
      $('#sa-jeweler_services_holder').next('.max-w-3xl.mx-auto.mt-6').hide();
      $('<div class="max-w-3xl mx-auto mt-6" id="custom_form"><h2>Interested to sell your diamond at this price?</h2><div><button type="button" class="btn gia-contact-btn">Yes</button><div class="gia-form-target"></div></div></div>').insertAfter( "#sa-jeweler_services_holder" );
	  $('#FetchVal').removeAttr('disabled');

//       setTimeout(function(){
//         $('#'+append_div).find('img[src]').each(function (i, e) {
//           var oldurl = $(this).attr('src');
//           if(validURL(oldurl)){
//           }else{
//             $(this).attr('src','https://www.stonealgo.com/'+oldurl)
//           }
//         });

//         backgroung_image();
//         $('.gia-result-loader').hide();
//         $("#FetchVal").removeAttr('disabled');
//         $('#'+append_div).show();
        
//         $('.gia-contact-btn').click(function(){
//           $(this).hide();
//           $('.gia-form-target').html($('.gia-hidden-form').html());
//         });
//       },3000);
        
        $('#'+append_div).html(data);
        $('#'+append_div).filter('script[src]').each(function (i, e) {
          var script = document.createElement('script');
          script.src = (e.nodeName == "LINK") ? $(this).attr('href') : $(this).attr('src');
          script.type = 'text/javascript';
          document.getElementsByTagName('head')[0].appendChild(script);
          $(this).remove();
        });

        var getcss = new Array();
        $('#'+append_div).filter('link[rel="stylesheet"]').each(function (i, e) {
          var css = document.createElement("link");
          css.type = "text/css";
          css.rel = "stylesheet";
          css.href = (e.nodeName == "LINK") ? $(this).attr('href') : $(this).attr('src');
          document.getElementsByTagName('head')[0].append(css);

        });  
      	
      setTimeout(function(){
        reload_image(append_div);
		$('.gia-result-loader').hide();	
        $('#sa-cert_link').parent().removeClass('hidden');
        $('.gia-contact-btn').click(function(){
          $(this).hide();
          $('.gia-form-target').html($('.gia-hidden-form').html());
        });	
        
      },3000);
      
      $('.mobile-thumb-item').click(function(){
        setTimeout(function(){
          reload_image('all_data');
        });
      });	
      $('#sa-blocker').remove();  
      
      
       $('#sa-main_img').attr('src','https://www.stonealgo.com/static/dist/img/ringonhand.jpg'); 
       $('#visual-carat-image').css('background-image','url("https://www.stonealgo.com/static/dist/images/diamond-trans2.png")');
       $('#sa-d_on_hand').removeClass('hidden');
       $('#sa-cert_link').html('<a class="relative text-sm leading-5 text-blue-500 hover:text-blue-700 font-medium" id="sa-cert_request_special" href="https://www.gia.edu/report-check?reportno='+search+'" target="_blank">View Certificate</a>'); 
    }
//     }
    
    
    
    
  });
  
  function reload_image(append_div){

    $('#'+append_div).find('img[src]').each(function (i, e) {
      //             console.log($(this));
      var oldurl = $(this).attr('src');
      console.log(oldurl);
      oldurl = oldurl.replace(/\s/g, '%20')
      
      if(validURL(oldurl)){
        
      }else{
        
        $(this).attr('src','https://www.stonealgo.com'+oldurl)
      }


    });

    backgroung_image();

    $('#'+append_div).show();       
  }

  function backgroung_image(){
    $('#all_data').find('div').each(function(){
      var bg = $(this).css('background-image');
      var bgurl = bg.replace('url(','').replace(')','').replace(/\"/gi, "");
      if(bgurl!='none'){
        var sub = bgurl.split('/');
        var newurl = new Array();
        if(sub[2]=='www.ryderdiamonds.com'){
          sub.forEach(function(item,val){
            if(val==2){
              newurl.push('www.stonealgo.com');
            }else{
              newurl.push(item);
            }
          });
        }
        if(newurl!=''){
          var findurl = newurl.join('/');

          $(this).css('background-image','url('+findurl+')');
        }
      }
    });
  }    

  function validURL(str) {
    var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
                             '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
                             '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
                             '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
                             '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
                             '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    return !!pattern.test(str);
  }
}
